import { useFormContext } from "react-hook-form";

import { ErrorHint } from "src/base-components/ErrorHint";
import { Input } from "src/base-components/Input";
import { Label } from "src/base-components/Label";
import { FormStepWrapper } from "src/cases/templates/FormStepWrapper";
import { getStepById } from "src/cases/templates/formSteps";
import { CaseTemplateFormValues } from "src/cases/templates/formUtils/types";
import { useCheckFieldPermission } from "src/cases/templates/useCheckFieldPermission";

export const DefineVersionSettingsStep: React.FC = () => {
  const step = getStepById("define-version-settings");
  const form = useFormContext<CaseTemplateFormValues>();
  const hasPermission = useCheckFieldPermission();

  const {
    formState: { errors },
  } = form;

  return (
    <FormStepWrapper description={step.description} title={step.title}>
      <div className="flex flex-col content-stretch items-start justify-start gap-3 rounded-lg bg-gray-50 px-4 py-3">
        <div className="flex w-full items-start justify-start gap-2">
          <div className="flex flex-1 flex-col">
            <Label required>Version name</Label>
            <Input
              data-loc="version-name-input"
              disabled={!hasPermission("edit", "attributes.version_name")}
              errored={Boolean(errors.attributes?.version_name)}
              placeholder="Enter template version name"
              fullWidth
              {...form.register("attributes.version_name")}
            />
            {errors.attributes?.version_name?.message && (
              <ErrorHint>{errors.attributes.version_name.message}</ErrorHint>
            )}
          </div>
        </div>
      </div>
    </FormStepWrapper>
  );
};
